<template>
    <section class="mt-56 pb-5">
        <h3 class="h3 cabinet-section__dashboard-title">Полезные ссылки</h3>

        <div class="row dashboard-row align-items-stretch">
            <div class="col-12 dashboard-card dashboard-card--useful-links">
                <a
                    href="http://kliogem.ru/"
                    target="_blank"
                    class="dashboard-card--useful-links__link"
                >
                    <div
                        class="dashboard-card__content dashboard-card__content--useful-links d-flex justify-content-between align-items-center"
                    >
                        <img
                            src="/img/promo/1.png"
                            alt=""
                            class="dashboard-useful-links__img ofi"
                        />
                        <div class="dashboard-useful-links__descr mr-auto">
                            <div class="dashboard-useful-links__title">
                                Клио
                            </div>
                            Ювелирное и зуботехническое оборудование
                        </div>
                        <a
                            href="http://kliogem.ru/"
                            target="_blank"
                            class="dashboard-useful-links__link-icon align-self-start align-self-lg-center"
                        ></a>
                    </div>
                </a>
            </div>
        </div>

        <div class="row dashboard-row align-items-stretch">
            <div class="col-12 dashboard-card dashboard-card--useful-links">
                <a
                    href="http://dmetconsult.ru/"
                    target="_blank"
                    class="dashboard-card--useful-links__link"
                >
                    <div
                        class="dashboard-card__content dashboard-card__content--useful-links d-flex justify-content-between align-items-center"
                    >
                        <img
                            src="/img/promo/2.png"
                            alt=""
                            class="dashboard-useful-links__img ofi"
                        />
                        <div class="dashboard-useful-links__descr mr-auto">
                            <div class="dashboard-useful-links__title">
                                Драгметалконсалт
                            </div>
                            Консультационные центр по вопросам оборота
                            драгоценных металлов и камней
                        </div>
                        <a
                            href="http://dmetconsult.ru/"
                            target="_blank"
                            class="dashboard-useful-links__link-icon align-self-start align-self-lg-center"
                        ></a>
                    </div>
                </a>
            </div>
        </div>

        <div class="row dashboard-row align-items-stretch">
            <div class="col-12 dashboard-card dashboard-card--useful-links">
                <a
                    href="http://crystalit.ru/"
                    target="_blank"
                    class="dashboard-card--useful-links__link"
                >
                    <div
                        class="dashboard-card__content dashboard-card__content--useful-links d-flex justify-content-between align-items-center"
                    >
                        <img
                            src="/img/promo/3.png"
                            alt=""
                            class="dashboard-useful-links__img ofi"
                        />
                        <div class="dashboard-useful-links__descr mr-auto">
                            <div class="dashboard-useful-links__title">
                                Crystalit
                            </div>
                            Навстречу новому!
                        </div>
                        <a
                            href="https://crystalit.ru/"
                            target="_blank"
                            class="dashboard-useful-links__link-icon align-self-start align-self-lg-center"
                        ></a>
                    </div>
                </a>
            </div>
        </div>

        <div class="row dashboard-row align-items-stretch">
            <div class="col-12 dashboard-card dashboard-card--useful-links">
                <a
                    href="http://legor.com/"
                    target="_blank"
                    class="dashboard-card--useful-links__link"
                >
                    <div
                        class="dashboard-card__content dashboard-card__content--useful-links d-flex justify-content-between align-items-center"
                    >
                        <img
                            src="/img/promo/4.png"
                            alt=""
                            class="dashboard-useful-links__img ofi"
                        />
                        <div class="dashboard-useful-links__descr mr-auto">
                            <div class="dashboard-useful-links__title">
                                Legor
                            </div>
                            Легор групп трансформирует металлы, чтобы
                            подчеркнуть их великолепные природные свойства и
                            возродить их прежнее сияние
                        </div>
                        <a
                            href="https://www.legor.com/"
                            target="_blank"
                            class="dashboard-useful-links__link-icon align-self-start align-self-lg-center"
                        ></a>
                    </div>
                </a>
            </div>
        </div>

        <div class="row dashboard-row align-items-stretch">
            <div class="col-12 dashboard-card dashboard-card--useful-links">
                <a
                    href="http://sapphire.ru/"
                    target="_blank"
                    class="dashboard-card--useful-links__link"
                >
                    <div
                        class="dashboard-card__content dashboard-card__content--useful-links d-flex justify-content-between align-items-center"
                    >
                        <img
                            src="/img/promo/5.png"
                            alt=""
                            class="dashboard-useful-links__img ofi"
                        />
                        <div class="dashboard-useful-links__descr mr-auto">
                            <div class="dashboard-useful-links__title">
                                Сапфир
                            </div>
                            Искусственно выращенные бриллианты от Алмазной Биржи
                            Израиля
                        </div>
                        <a
                            href="https://www.sapphire.ru/"
                            target="_blank"
                            class="dashboard-useful-links__link-icon align-self-start align-self-lg-center"
                        ></a>
                    </div>
                </a>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'UsefulLinks'
}
</script>
